'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';
import { MonitoringUtils } from '@quartz-iam-legacy/app/monitoring/monitoringUtils';

function isFeatureFlag(feature) {
    return typeof feature?.Name === 'string' && typeof feature?.IsActive === 'boolean';
}

angular.module('services.featureService', [])

.factory('featureService', ['$http', function ($http) {
    var service = {};
    var baseUrl = environment.apiUrl + '/ID/api/Features';
    var _featuresPromise = null;

    function loadFeatures() {
        return $http.get(baseUrl)
            .then(function (response) {
                var features = response.data;
                var flags = Array.isArray(features) ? features.filter(isFeatureFlag) : [];

                if (flags.length === 0 && (!Array.isArray(features) || features.length > 0)) {
                    MonitoringUtils.captureMessage('Feature toggles payload not recognised', {
                        level: 'error',
                        extra: {
                            received: Array.isArray(features) ? 'array' : typeof features,
                            length: Array.isArray(features) ? features.length : undefined,
                            firstEntryKeys: Array.isArray(features) && features[0] ? Object.keys(features[0]) : undefined,
                        },
                    });
                }

                return new Map(flags.map((flag) => [flag.Name, flag.IsActive]));
            })
            .catch((error) => {
                MonitoringUtils.captureMessage('Feature toggles could not be loaded', {
                    level: 'error',
                    tags: { status: error?.status },
                });
                _featuresPromise = null;

                return new Map();
            });
    }

    service.getFeatures = function () {
        if (!_featuresPromise) {
            _featuresPromise = loadFeatures();
        }

        return _featuresPromise;
    }

    service.hasFeature = function (feature) {
        return service.getFeatures().then((features) => {
            return !!(feature && features.has(feature) ? features.get(feature) : false);
        });
    }

    return service;
}]);
